import { BsFillMusicPlayerFill } from 'react-icons/bs'
import PlayerList from './PlayerList'
import PlayerEdit from './PlayerEdit'

export default {
  list: PlayerList,
  edit: PlayerEdit,
  icon: BsFillMusicPlayerFill,
}
